// extracted by mini-css-extract-plugin
module.exports = {"button-box":"button-box__3KCmW","fixed-button":"fixed-button__1urvu","fixed-button__prev":"fixed-button__prev__3d7YV"};